"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builderFor = void 0;
const newContext = () => {
    const sequences = {};
    return {
        next: (name) => {
            sequences[name] = sequences[name] || 0;
            return sequences[name]++;
        }
    };
};
function initialize(initializer, context) {
    if (typeof initializer == 'function') {
        return initializer(context);
    }
    else {
        return initializer;
    }
}
const builderFor = (defaults) => {
    const context = newContext();
    const builder = (overrides = {}) => (Object.assign(Object.assign({}, initialize(defaults, context)), overrides));
    return builder;
};
exports.builderFor = builderFor;
